module.exports = __webpack_public_path__ + "img/businesLicense.b194add6.png";